import * as React from 'react';
import Button from "./Button";
import {Modal, ModalBody, ModalFooter, ModalHeader, Table} from "reactstrap";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";

function SmsApiContentLengthModal(props) {
  const { t } = useTranslation('sms_api_content_length_modal')
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggleModalOpen = () => setModalOpen(!modalOpen);

  return <React.Fragment>
    <div className="btn btn-light btn-sm cursor-pointer" onClick={toggleModalOpen}>
      <i className="fas fa-info-circle"/>
      {props.instructionBtnText && <span>{t('btn')}</span>}
    </div>
    <Modal isOpen={modalOpen} toggle={toggleModalOpen} size="xl">
      <ModalHeader toggle={toggleModalOpen}>{t('modal.header')}</ModalHeader>
      <hr className="my-0"/>
      <ModalBody>
        <Table bordered size="sm">
          <thead>
          <tr>
            <th style={{width: '150px'}}>{t('modal.body.table.column.parts')}</th>
            <th>{t('modal.body.table.column.without_special')}</th>
            <th>
              <span>{t('modal.body.table.column.with_special')}</span>
              <span className="small ml-2">{t('modal.body.table.column.with_special_hint')}</span>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 1})}</td>
            <td>{t('modal.body.table.row.chars', {count: 160})}</td>
            <td>{t('modal.body.table.row.chars', {count: 70})}</td>
          </tr>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 2})}</td>
            <td>{t('modal.body.table.row.chars', {count: 306})}</td>
            <td>{t('modal.body.table.row.chars', {count: 134})}</td>
          </tr>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 3})}</td>
            <td>{t('modal.body.table.row.chars', {count: 459})}</td>
            <td>{t('modal.body.table.row.chars', {count: 201})}</td>
          </tr>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 4})}</td>
            <td>{t('modal.body.table.row.chars', {count: 612})}</td>
            <td>{t('modal.body.table.row.chars', {count: 268})}</td>
          </tr>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 5})}</td>
            <td>{t('modal.body.table.row.chars', {count: 765})}</td>
            <td>{t('modal.body.table.row.chars', {count: 335})}</td>
          </tr>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 6})}</td>
            <td>{t('modal.body.table.row.chars', {count: 918})}</td>
            <td>{t('modal.body.table.row.chars', {count: 402})}</td>
          </tr>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 7})}</td>
            <td>{t('modal.body.table.row.chars', {count: 1071})}</td>
            <td>{t('modal.body.table.row.chars', {count: 469})}</td>
          </tr>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 8})}</td>
            <td>{t('modal.body.table.row.chars', {count: 1224})}</td>
            <td>{t('modal.body.table.row.chars', {count: 536})}</td>
          </tr>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 9})}</td>
            <td>{t('modal.body.table.row.chars', {count: 1377})}</td>
            <td>{t('modal.body.table.row.chars', {count: 603})}</td>
          </tr>
          <tr>
            <td>{t('modal.body.table.row.parts', {count: 10})}</td>
            <td>{t('modal.body.table.row.chars', {count: 1530})}</td>
            <td>{t('modal.body.table.row.chars', {count: 670})}</td>
          </tr>
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>{t('common:btn.close')}</Button>
      </ModalFooter>
    </Modal>
  </React.Fragment>
}

SmsApiContentLengthModal.defaultProps = {
  instructionBtnText: true,
}

SmsApiContentLengthModal.propTypes = {
  instructionBtnText: PropTypes.bool
};

export default SmsApiContentLengthModal;